/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Send at the soonest window opportunity not before ``at_time``.
 *
 * Automatic-email only. The base time is the anchor's day at ``at_time``
 * (sender-local) when the anchor is before it, otherwise the next day at
 * ``at_time``; the universal window clamp then rolls it onto the next
 * enabled sending window. Tasks never use this mode.
 */
export interface StepScheduleSoonestAt {
  mode: 'soonest_at';
  /** @pattern ^\d{2}:\d{2}$ */
  at_time: string;
}
